import { useMutation } from '@tanstack/react-query'

import { createJobSchedule } from '../services/createJobSchedule'

export { useCreateJobSchedule }

const useCreateJobSchedule = () => {
  return useMutation({
    mutationFn: createJobSchedule,
  })
}
